import { gql } from '@apollo/client'

// The Coach Analytics fields behind the month-by-month charts, requested for
// the selected month and the month before it.
export const GET_BUSINESS_AT_A_GLANCE = gql`
  query BusinessAtAGlance($timeRange: PGACoachAnalyticsTimeRangeInput) {
    pgaCoachAnalytics(timeRange: $timeRange) {
      earnings {
        byMonth {
          month
          total
        }
      }
      groupEvents {
        byMonth {
          month
          count
        }
      }
      privateLessonTypes {
        byMonth {
          month
          count
        }
      }
      rebookingRateByMonth {
        month
        rate
      }
      newStudentsByMonth {
        month
        count
      }
    }
  }
`
